import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules
} from '@mui/styles';
import {TextField} from '@mui/material';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import DefinitionSection from '~common/form/definition-section-fc';
import CustomDefinitionRenderer from '~common/form/custom-definition-renderer-example';
import DefinitionDataProvider from "~common/form/icg-definition-data-provider";
import CustomFieldRenderer from '~common/form/custom-field-renderer-example';
import MetadataView from '~common/form/metadata-edit-view';
import PortalUser from '~common/lib/portal-user-context';
import {FormDefinition} from '~common/lib/models/form-definition';
import ErrorView from '~common/components/error-view';
import {Definition} from '~common/lib/types';
import {Button} from '@mui/material';
import {Paper, Grid, Typography, IconButton} from '@mui/material';
import {FormType} from '~common/lib/models/form-type';

import YAML from 'js-yaml';
import AceEditor from 'react-ace';




import 'brace/mode/yaml';
import 'brace/theme/github';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    marginBottom: 45
  },
  sectionTitle: {
    marginBottom: 15,
    borderBottom: '1px solid #ccc',
    display: 'flex',
    justifyContent: 'space-between'
  },
  textArea: {
    width: '100%',
    height: 400
  },
  headerPaper: {
    padding: 15,
    marginBottom: 15
  },
  definitionHeader: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    borderBottom: '1px solid #ccc',
    marginBottom: 15
  },
  formToolbar: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  formToolbarIconButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 45
  },
  formToolbarIcon: {
    fontSize: '0.95rem',
    width: 22
  },
  formToolbarIconActive: {
    fontSize: '0.95rem',
    color: 'purple',
    width: 22
  },
  formField: {
    width: '100%'
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  actionButton: {
    marginLeft :15
  },
  yamlEditor: {
    width: 'calc(100% - 30px)',
    height: 'calc(100% - 60px)'
  },
  column: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any;
}

type State = {
  form?: FormDefinition;
  path: string;
  status: 'ready' | 'loading' | 'saving';
  currentTab: number;
  definition?: Definition;
  definitionJson?: any;
  definitionYaml?: any;
  definitionError?: any;
  id?: number;
  data?: any;
  dataJson?: any;
  dataError?: any;
  error?: any;
  policyMessages?: Array<any>;
  previewMode?: boolean;
  dirty?: boolean;
};

class FormAdminEditView extends React.Component<
Props & WithStyles<keyof typeof styles>,
State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {

    super(props, {});
    this.state = {
      status: 'loading',
      path: '',
      data: {},
      currentTab: 0,
      dataJson:"{}"
    };
    const {match} = props;
    if(match && match.params && match.params.id){
      this.state.id = match.params.id;
    }
  }

 componentDidMount() {

    const {match} = this.props;
    var selectedFormID:any
    if(match && match.params && match.params.id){
      selectedFormID = match.params.id;
    }

    if (selectedFormID == 'new') {
      FormType.query({})
        .then((data: Array<FormType>) => {
          if (data.length > 0) {
            const dd:any = new Definition(data[0].baseDefinition.value);
            const dj:any = JSON.stringify(dd, null, 2);
            this.setState({
              form: new FormDefinition({formType: data[0].key.value}),
              definition: new Definition(data[0].baseDefinition.value),
              definitionJson: dj,
              status: 'ready'
            });
          }
        })
        .catch((err) => {
          this.setState({error: err, status: 'ready'});
        });
    } else {
      FormDefinition.get(selectedFormID)
        .then((data: FormDefinition) => {
          if(data){
            const dr:any = new Definition(data.definition.value || {})
            if(dr){
              try{
                let dj:any = JSON.stringify(data.definition.value || {}, null, 2);
                let dy:any = YAML.dump(data.definition.value || {});
                this.setState({
                  form: data,
                  definition: new Definition(data.definition.value),
                  definitionJson: dj,
                  definitionYaml: dy,
                  status: 'ready'
                });
              } catch(e) {
                this.setState({
                  form: data,
                  definition: new Definition(data.definition.value),
                  status: 'ready'
                });
                console.error(e)
              }
            }
          }

        })
        .catch((err) => {
          console.error(err);
          this.setState({error: err, status: 'ready'});
        });
    }
  }

  // handleChangeAtPath is used to ferry changes from owned omponents upstream
  handleChangeAtPath = (path: string, value: any) => {
    return;
    const patchUrl = '/api/vendor-bid/' + this.state.id + '/' + path;
    const self = this;
    let jsonbValue = JSON.stringify(value);

    request('PATCH', patchUrl)
      .send(jsonbValue)
      .end(function(err, response) {
        if (err) {
          //Handle error
          console.error(err.message);
          self.setState({error: err.message});
        } else {
          if (response.status !== 200) {
            //Handle error
            console.error(response.error.message);
            self.setState({error: response.error.message});
          } else {
            // Looks like we succeeded, so nothing to do
          }
        }
      });
  };

  handleTextDefinitionChange = (evt: any) => {
    if (evt.target && evt.target.value) {
      try       {
        //const def = YAML.load(evt.target.value)
        this.setState({definitionJson: evt.target.value});
      } catch (e) {
        this.setState({definitionError: e.toString()});
      }
    }
  };

  handleYamlDefinitionChange = (newVal: any) => {
      this.setState({definitionYaml: newVal}, ()=>{
        try       {
          const defRaw = YAML.load(newVal) 
          if(defRaw) {
            const def:any = new Definition(defRaw);
            const defJson:any = JSON.stringify(defRaw, null, 2);
            this.setState({definition:def, definitionJson: defJson});
          }
        } catch (e) {
          this.setState({definitionError: e.toString()});
        }
      });
  };

  handleCommitTextDefinitionChange = (evt: any) => {
    if (evt.target && evt.target.value) {
      try {
        this.setState({definitionJson: evt.target.value});
        const d = YAML.load(evt.target.value)
        this.setState({
          definition: new Definition(d),
          definitionError: undefined
        });
      } catch (e) {
        this.setState({definitionError: e.toString()});
      }
    }
  };

  handleDefinitionChange = (def: Definition) => {
    const {form} = this.state
    if(form && form.definition){
      form.definition.value = def
      this.setState({form: form, definition: def, definitionError: undefined});
    }
  };

  handleDataChange = (evt: any) => {
    const {data} = this.state;
    if (evt.target && evt.target.value) {
      try {
        this.setState({dirty: true, dataJson: evt.target.value});
        const d = JSON.parse(evt.target.value);
        data['bidData'] = d;
        this.setState({dirty: true, data: data, dataError: undefined});
      } catch (e) {
        this.setState({dataError: e.toString()});
      }
    }
  };

  handlePreviewModeChange = (evt: any) => {
    this.setState({previewMode: evt.target.checked});
    // If it is placed in the tile of an expanded panel, prevent bubbling.
    evt.preventDefault();
    evt.stopPropagation();
  };

  handleFormChange = (attribute: any) => (evt: any) => {
    const {form} = this.state;
    if (form && form[attribute]) {
      form[attribute].value = evt.target.value;
      this.setState({form});
    }
  };

  handleMetadataChange = (metadata: any) => {
    const {form} = this.state;
    if (form && form['extendedAttributes']) {
      form['extendedAttributes'].value = metadata;
      this.setState({form});
    }
  };


  handleSaveForm = () => {
   
    const {form, definition} = this.state
    // Set the definition on the form
    if(form && form.definition){
      form.definition.value = definition
    }

    this.setState({status: 'saving'}, () => {
      if (form && form.save) {
        form.save()
          .then((data) => {
            this.setState({status: 'ready'});
          })
          .catch((err) => {
            this.setState({error: err, status: 'ready'});
          });
      } else {
        this.setState({status: 'ready'});
      }
    });
  };

  handleCloseForm = () => {
    this.props.history.goBack();
  };

  handleTabChange = (value) => (evt: any) => {
    let previewMode = false;
    if (value === 1) {
      previewMode = true;
    }
    this.setState({previewMode: previewMode, currentTab: value});
  };

  render() {
    const {classes}: {classes: any} = this.props;
    const {
      path,
      status,
      form,
      data,
      dataJson,
      dataError,
      definition,
      definitionYaml,
      definitionError,
      policyMessages,
      currentTab,
      error
    } = this.state;
    const self = this;

    switch (status) {
      case 'loading':
        return <LoadingView classes={{}} />;
        break;

      case 'ready':
      case 'saving':
        var errorView: any = null;
        if (error) {
          errorView = <ErrorView classes={{}} error={error} />;
        }

        return (
          <DefinitionDataProvider>
          <div>
            {errorView}
            <Paper className={classes.headerPaper}>
              <Typography className={classes.headerTitle} variant="h6">
                Form Information
              </Typography>
              <Grid container spacing={3}>
                <Grid item md={6}>
                  {form && form.id && (
                    <TextField
                      label="Title"
                      className={classes.formField}
                      InputLabelProps={{
                      }}
                      disabled={form.id.value ? true : false}
                      margin="normal"
                      value={form.title.value || ''}
                      error={form.title.error ? true : false}
                      helperText={form.title.error ? form.title.error : ''}
                      onChange={this.handleFormChange('title')}
                    />
                  )}
                </Grid>
                <Grid item md={12}>
                  {form && form.title && (
                    <TextField
                      label="Description"
                      className={classes.formField}
                      InputLabelProps={{
                      }}
                      multiline
                      margin="normal"
                      value={form.description.value || ''}
                      error={form.description.error ? true : false}
                      helperText={
                        form.description.error ? form.description.error : ''
                      }
                      onChange={this.handleFormChange('description')}
                    />
                  )}
                </Grid>
                {form && PortalUser.hasOneOfFeatures(['form_development']) && (
                  <Grid item xs={12} sm={12} md={8} lg={6}>
                    <Typography variant="subtitle1">Metadata</Typography>
                    <MetadataView
                      metadata={form.extendedAttributes.value}
                      onMetadataChange={this.handleMetadataChange}
                    />
                  </Grid>
                )}
              </Grid>
            </Paper>
            <Paper className={classes.headerPaper}>
              <div className={classes.definitionHeader}>
                <Typography className={classes.headerTitle} variant="h6">
                  Definition
                </Typography>
                <div className={classes.formToolbar}>
                  <IconButton
                    size="large"
                    className={classes.formToolbarIconButton}
                    onClick={this.handleTabChange(0)}
                    aria-label="Admin">
                    <i
                      className={
                        (currentTab === 0
                          ? classes.formToolbarIconActive
                          : classes.formToolbarIcon) + ' fas fa fa-cogs'
                      }
                    />
                  </IconButton>
                  <IconButton
                    size="large"
                    className={classes.formToolbarIconButton}
                    onClick={this.handleTabChange(1)}
                    aria-label="Preview">
                    <i
                      className={
                        (currentTab === 1
                          ? classes.formToolbarIconActive
                          : classes.formToolbarIcon) + ' fas fa fa-eye'
                      }
                    />
                  </IconButton>
                  <IconButton
                    size="large"
                    className={classes.formToolbarIconButton}
                    onClick={this.handleTabChange(2)}
                    aria-label="Raw">
                    <i
                      className={
                        (currentTab === 2
                          ? classes.formToolbarIconActive
                          : classes.formToolbarIcon) + ' fas fa fa-code'
                      }
                    />
                  </IconButton>
                </div>
              </div>
              <Grid spacing={0} container>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} />
                {currentTab === 0 && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div>
                      <DefinitionSection
                        adminMode={true}
                        data={data.bidData}
                        definition={definition || new Definition()}
                        path={path}
                        policyMessages={policyMessages}
                        onChangeAtPath={self.handleChangeAtPath}
                        onDefinitionChange={self.handleDefinitionChange}
                        customRenderers={{
                          CustomDefinitionRenderer: CustomDefinitionRenderer,
                          CustomFieldRenderer: CustomFieldRenderer
                        }}
                        gridSpacing={2}
                      />
                    </div>
                  </Grid>
                )}
                {currentTab === 1 && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div>
                      <DefinitionSection
                        adminMode={false}
                        data={data.bidData}
                        definition={definition  || new Definition()}
                        path={path}
                        policyMessages={policyMessages}
                        onChangeAtPath={self.handleChangeAtPath}
                        onDefinitionChange={self.handleDefinitionChange}
                        customRenderers={{
                          CustomDefinitionRenderer: CustomDefinitionRenderer,
                          CustomFieldRenderer: CustomFieldRenderer
                        }}
                        suppressTitle
                        gridSpacing={2}
                      />
                    </div>
                  </Grid>
                )}
                {currentTab === 2 && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography
                      className={classes.sectionTitle}
                      variant="h5"
                      gutterBottom>
                      Form Definition
                    </Typography>
                    <AceEditor
                      className={classes.yamlEditor}
                      mode="yaml"
                      showPrintMargin={false}
                      highlightActiveLine={true}
                      style={{width:'99%'}}
                      theme="github"
                      onChange={self.handleYamlDefinitionChange}
                      name="definitionYaml"
                      maxLines={40}
                      value={definitionYaml}
                    />
                    {definitionError}
              </Grid>

                )}
                {false && currentTab === 2 && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography
                      className={classes.sectionTitle}
                      variant="h5"
                      gutterBottom>
                      Javascript Object
                    </Typography>
                    <textarea
                      className={classes.textArea}
                      onChange={self.handleDataChange}
                      value={dataJson}
                    />
                    {dataError}
                  </Grid>
                )}
              </Grid>
            </Paper>
            <div className={classes.actionBar}>
              <Button
                className={classes.actionButton}
                variant="contained"
                color="primary"
                onClick={this.handleSaveForm}
                disabled={status === 'saving'}>
                Save
              </Button>
              <Button
                className={classes.actionButton}
                variant="contained"
                color="inherit"
                onClick={this.handleCloseForm}
                >
                Close
              </Button>
              
            </div>
          </div>
          </DefinitionDataProvider>
        );
    }
  }
}

export default withStyles(styles)(FormAdminEditView);
